import React, { useRef, useEffect, useState } from "react";

const Team = ({ data }) => {
    const teamCardsWrapRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    useEffect(() => {
        const teamCardsWrap = teamCardsWrapRef.current;

        if (teamCardsWrap) {
            const handleMouseDown = (e) => {
                setIsDragging(true);
                setStartX(e.clientX);
                setScrollLeft(teamCardsWrap.scrollLeft);
            };

            const handleMouseMove = (e) => {
                if (isDragging) {
                    const deltaX = e.clientX - startX;
                    teamCardsWrap.scrollLeft = scrollLeft - deltaX;
                }
            };

            const handleMouseUp = () => {
                setIsDragging(false);
            };

            const handleWheel = (e) => {
                e.preventDefault();
                teamCardsWrap.scrollLeft += e.deltaY;

                // Проверяем достигнут ли край
                if (teamCardsWrap.scrollLeft === 0 || teamCardsWrap.scrollLeft + teamCardsWrap.clientWidth >= teamCardsWrap.scrollWidth) {
                    window.scrollBy(0, e.deltaY);
                }
            };

            const handleTouchStart = (e) => {
                setIsDragging(true);
                setStartX(e.touches[0].clientX);
                setScrollLeft(teamCardsWrap.scrollLeft);
            };

            const handleTouchMove = (e) => {
                if (isDragging) {
                    const deltaX = e.touches[0].clientX - startX;
                    teamCardsWrap.scrollLeft = scrollLeft - deltaX;
                }
            };

            const handleTouchEnd = () => {
                setIsDragging(false);
            };

            teamCardsWrap.addEventListener('mousedown', handleMouseDown);
            teamCardsWrap.addEventListener('mousemove', handleMouseMove);
            teamCardsWrap.addEventListener('mouseup', handleMouseUp);
            teamCardsWrap.addEventListener('mouseleave', handleMouseUp);
            teamCardsWrap.addEventListener('wheel', handleWheel);

            // Добавляем обработчики событий для касания
            teamCardsWrap.addEventListener('touchstart', handleTouchStart);
            teamCardsWrap.addEventListener('touchmove', handleTouchMove);
            teamCardsWrap.addEventListener('touchend', handleTouchEnd);

            return () => {
                teamCardsWrap.removeEventListener('mousedown', handleMouseDown);
                teamCardsWrap.removeEventListener('mousemove', handleMouseMove);
                teamCardsWrap.removeEventListener('mouseup', handleMouseUp);
                teamCardsWrap.removeEventListener('mouseleave', handleMouseUp);
                teamCardsWrap.removeEventListener('wheel', handleWheel);

                // Удаляем обработчики событий для касания
                teamCardsWrap.removeEventListener('touchstart', handleTouchStart);
                teamCardsWrap.removeEventListener('touchmove', handleTouchMove);
                teamCardsWrap.removeEventListener('touchend', handleTouchEnd);
            };
        }
    }, [isDragging, startX, scrollLeft]);

    return (
        <div className={`bg-[${data.bg_color}] mx-auto w-[95%] p-4 rounded-[20px] min-h-[500px] h-fit mt-[5%] flex flex-col font-manrope`}>
    <div className="flex flex-col gap-8 lg:flex-row items-start justify-between w-full">
        <span className="lg:w-[40%] w-[80%] text-3xl lg:text-5xl">{data.head_title}</span>
        <span className="lg:w-[40%] w-[80%] text-base md:text-[24px] lg:text-2xl">{data.head_description}</span>
    </div>

    <div className="mt-[5%] flex flex-nowrap overflow-hidden scroll-snap-x mandatory w-full" ref={teamCardsWrapRef}>
        <div className={`w-3/12 min-w-[350px] aspect-[380/463] bg-[${data.member_1.bg_color}] h-[90%] rounded-[15px] relative mr-[20px] scroll-snap-start flex-shrink-0  bg-no-repeat bg-center`} style={{backgroundSize: 'auto 100%', backgroundImage: `url(${data.member_1.bg_image})` }}>
            <div className={`w-[90%] aspect-[370/34] p-[4%] bg-[${data.member_1.bar_color}] rounded-[14px] absolute bottom-[3%] left-[4%] flex items-center justify-between`}>
                <span className="text-[110%] font-medium">{data.member_1.name}</span>
                <span style={{backgroundColor: `${data.member_1.description_bg_color}`, color: `${data.member_1.description_color}`}} className={`bg-[${data.member_1.description_bg_color}] rounded-full text-[90%] text-[${data.member_1.description_color}] py-[2%] px-[4%]`}>{data.member_1.description}</span>
            </div>
        </div>

        <div className={`w-3/12 min-w-[350px] aspect-[380/463] bg-[${data.member_2.bg_color}] h-[90%] rounded-[15px] relative mr-[20px] scroll-snap-start flex-shrink-0  bg-no-repeat bg-center`} style={{backgroundSize: 'auto 100%', backgroundImage: `url(${data.member_2.bg_image})` }}>
            <div className={`w-[90%] aspect-[370/34] p-[4%] bg-[${data.member_2.bar_color}] rounded-[14px] absolute bottom-[3%] left-[1%] flex items-center justify-between`}>
                <span className="text-[110%] font-medium">{data.member_2.name}</span>
                <span style={{backgroundColor: `${data.member_2.description_bg_color}`, color: `${data.member_2.description_color}`}} className={`bg-[${data.member_2.description_bg_color}] rounded-full text-[90%] text-[${data.member_2.description_color}] py-[2%] px-[4%]`}>{data.member_2.description}</span>
            </div>
        </div>

        <div className={`w-3/12 min-w-[350px] aspect-[380/463] bg-[${data.member_3.bg_color}] h-[90%] rounded-[15px] relative mr-[20px] scroll-snap-start flex-shrink-0  bg-no-repeat bg-center`} style={{backgroundSize: 'auto 100%', backgroundImage: `url(${data.member_3.bg_image})` }}>
            <div className={`w-[90%] aspect-[370/34] p-[4%] bg-[${data.member_3.bar_color}] rounded-[14px] absolute bottom-[3%] left-[1%] flex items-center justify-between`}>
                <span className="text-[110%] font-medium">{data.member_3.name}</span>
                <span style={{backgroundColor: `${data.member_3.description_bg_color}`, color: `${data.member_3.description_color}`}} className={`bg-[${data.member_3.description_bg_color}] rounded-full text-[90%] text-[${data.member_3.description_color}] py-[2%] px-[4%]`}>{data.member_3.description}</span>
            </div>
        </div>

        <div className={`w-3/12 min-w-[350px] aspect-[380/463] bg-[${data.member_4.bg_color}] h-[90%] rounded-[15px] relative mr-[20px] scroll-snap-start flex-shrink-0  bg-no-repeat bg-center`} style={{backgroundSize: 'auto 100%', backgroundImage: `url(${data.member_4.bg_image})` }}>
            <div className={`w-[90%] aspect-[370/34] p-[4%] bg-[${data.member_4.bar_color}] rounded-[14px] absolute bottom-[3%] left-[1%] flex items-center justify-between`}>
                <span className="text-[110%] font-medium">{data.member_4.name}</span>
                <span style={{backgroundColor: `${data.member_4.description_bg_color}`, color: `${data.member_4.description_color}`}} className={`bg-[${data.member_4.description_bg_color}] rounded-full text-[90%] text-[${data.member_4.description_color}] py-[2%] px-[4%]`}>{data.member_4.description}</span>
            </div>
        </div>
    </div>
</div>

    );
}

export default Team;
